<template>
  <div>
    <el-form ref="loginForm" :model="form" :label-position="labelPosition"
             label-width="120px" style="margin-left: 400px;margin-top: 100px">
      <el-form-item label="用户名">
        <el-input type="text" style="width: 400px" v-model="form.user_name" :disabled="true"/>
      </el-form-item>
      <el-form-item label="姓名">
        <el-input type="text" style="width: 400px" v-model="form.real_name" :disabled="true"/>
      </el-form-item>
      <el-form-item label="手机号码" prop="invite_code">
        <el-input type="text" style="width: 400px" v-model="form.mobile_phone" :disabled="true"/>
      </el-form-item>
      <el-form-item label="密码" >
        <el-input type="text" placeholder="密码" v-model="passForm.new_password" style="width: 400px">
        <el-button slot="append" style="background-color: #67C23A;color: #ffffff" @click="changePassword">修改密码</el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="提现密码" >
        <el-input type="text" placeholder="提现密码" v-model="passForm2.new_password" style="width: 400px">
        <el-button slot="append" style="background-color: #67C23A;color: #ffffff" @click="changePassword2">修改密码</el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <!--修改密码-->
    <el-dialog title="修改密码" :visible.sync="dialogFormVisible">
      <el-form :model="passForm" ref="loginForm" :rules="rules" style="margin-left: 100px">
        <el-form-item label="原密码" :label-width="formLabelWidth" prop="password">
          <el-input v-model="passForm.password" autocomplete="off" placeholder="请输入原密码"
                    style="width: 400px" type="password"></el-input>
        </el-form-item>
        <el-form-item label="新密码" :label-width="formLabelWidth" prop="new_password">
          <el-input v-model="passForm.new_password" autocomplete="off" placeholder="请输入新密码"
                    style="width: 400px" type="password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" :label-width="formLabelWidth" prop="affirm_new_password">
          <el-input v-model="passForm.affirm_new_password" autocomplete="off" placeholder="请输入确认密码"
                    style="width: 400px" type="password"></el-input>
        </el-form-item>
        <el-form-item label="验证码" :label-width="formLabelWidth" prop="code" >
          <el-input v-model="passForm.code" autocomplete="off" placeholder="请输入验证码" style="width: 400px">
            <el-button slot="append" style="background-color: #67C23A;color: #ffffff" :disabled="disabled" @click="getCode">{{ valiBtn }}</el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="change('loginForm')">确 定</el-button>
      </div>
    </el-dialog>

    <!--修改提现密码-->
    <el-dialog title="修改提现密码" :visible.sync="dialogFormVisible2">
      <el-form :model="passForm2" ref="loginForm2" :rules="rules2" style="margin-left: 100px">
        <el-form-item label="原支付密码" :label-width="formLabelWidth" prop="pay_password">
          <el-input v-model="passForm2.pay_password" autocomplete="off" placeholder="请输入正确的原始密码"
                    style="width: 400px" type="password"></el-input>
        </el-form-item>
        <el-form-item label="新支付密码" :label-width="formLabelWidth" prop="new_password">
          <el-input v-model="passForm2.new_password" autocomplete="off" placeholder="请输入正确的新密码"
                    style="width: 400px" type="password"></el-input>
        </el-form-item>
        <el-form-item label="确认支付密码" :label-width="formLabelWidth" prop="affirm_new_password">
          <el-input v-model="passForm2.affirm_new_password" autocomplete="off" placeholder="请输入确认密码"
                    style="width: 400px" type="password"></el-input>
        </el-form-item>
        <el-form-item label="验证码" :label-width="formLabelWidth" prop="code" >
          <el-input v-model="passForm.code" autocomplete="off" placeholder="请输入验证码" style="width: 400px">
            <el-button slot="append" style="background-color: #67C23A;color: #ffffff" :disabled="disabled" @click="getCode2">{{ valiBtn2 }}</el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel2">取 消</el-button>
        <el-button type="primary" @click="change2('loginForm2')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "masterMessage",//我的主信息页面
  data() {
    return {
      form: {},
      labelPosition: 'right',
      token: '',
      dialogFormVisible: false,
      passForm: {
        password:'',
        new_password:"",
        affirm_new_password:"",
        code:""
      },
      rules: {
        password: [{message: '请输入原密码', required: true, trigger: 'blur'}],
        new_password: [{message: '请输入新密码', required: true, trigger: 'blur'}],
        affirm_new_password: [{message: '请输入确认密码', required: true, trigger: 'blur'}],
        code: [{message: '请输入验证码', required: true, trigger: 'blur'}],
      },
      formLabelWidth: '120px',
      disabled: false,
      valiBtn: '获取验证码',
      phone:'',
      dialogFormVisible2: false,
      passForm2: {
        pay_password: "",
        new_password: "",
        affirm_new_password: "",
        code: ""
      },
      rules2: {
        pay_password: [{message: '请输入原支付密码', required: true, trigger: 'blur'}],
        new_password: [{message: '请输入新支密码', required: true, trigger: 'blur'}],
        affirm_new_password: [{message: '请输入确认密码', required: true, trigger: 'blur'}],
        code: [{message: '请输入验证码', required: true, trigger: 'blur'}],
      },
      disabled2: false,
      valiBtn2: '获取验证码',
    }
  },
  created() {
    this.token = sessionStorage.getItem("token");
    this.getData();
  },
  methods: {
    // 获取用户信息
    getData() {
      this.$api.post("/api/user/info?token=" + this.token, {}, res => {
        if (res.status == 200) {
          this.form = res.data;
          this.phone=res.data.mobile_phone;
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    //修改密码
    changePassword() {
      this.dialogFormVisible = true;
    },
    //修改提现密码
    changePassword2() {
      this.dialogFormVisible2 = true;
    },
    //获取验证码
    getCode() {
      let param = {
        phone: this.phone,
        type: 2
      }
      this.$api.post("/api/user_center/getVerificationCode", param, res => {
        if (res.status == 200) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      })
      this.tackBtn();   //验证码倒数60秒
    },
    tackBtn() {       //验证码倒数60秒
      let time = 60;
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          this.valiBtn = '获取验证码';
          this.disabled = false;
        } else {
          this.disabled = true;
          this.valiBtn = time + '秒后重试';
          time--;
        }
      }, 1000);
    },
    //修改密码确定
    change(formName){
      this.$refs[formName].validate((valid) => {    // 为表单绑定验证功能
        if (valid) {
          this.$api.post("/api/user_center/updatePassword", this.passForm, res => {
            if (res.status == 200) {
              this.$message.success(res.msg);
              this.dialogFormVisible=false;
            } else {
              this.$message.error(res.msg);
            }
          })
        }
      });
    },
    // 取消
    cancel(){
      this.passForm.password='';
      this.passForm.new_password='';
      this.passForm.affirm_new_password='';
      this.passForm.code='';
      this.dialogFormVisible=false;
    },

    //获取验证码
    getCode2() {
      let param = {
        phone: this.phone,
        type: 2
      }
      this.$api.post("/api/user_center/getVerificationCode", param, res => {
        if (res.status == 200) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      })
      this.tackBtn2();   //验证码倒数60秒
    },
    tackBtn2() {       //验证码倒数60秒
      let time = 60;
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          this.valiBtn2 = '获取验证码';
          this.disabled2 = false;
        } else {
          this.disabled2 = true;
          this.valiBtn2 = time + '秒后重试';
          time--;
        }
      }, 1000);
    },
    //修改支付密码确定
    change2(formName){
      this.$refs[formName].validate((valid) => {    // 为表单绑定验证功能
        if (valid) {
          this.$api.post("/api/user_center/updateWithdraw", this.passForm2, res => {
            if (res.status == 200) {
              this.$message.success(res.msg);
              this.dialogFormVisible2=false;
            } else {
              this.$message.error(res.msg);
            }
          })
        }
      });
    },
    // 取消
    cancel2(){
      this.passForm2.pay_password='';
      this.passForm2.new_password='';
      this.passForm2.affirm_new_password='';
      this.passForm2.code='';
      this.dialogFormVisible2=false;
    }
  },
}
</script>
<style>
.el-form-item {
  margin-bottom: 14px !important;
}
</style>
